import React, { useMemo } from 'react';
import { Square } from 'lucide-react';
import { svgHtmlToDataUrl } from '../lib/svgCapture';

const SummaryConfigThumbnail = ({
  svgData,
  saved = false,
  className = 'w-[72px] h-[72px]',
}) => {
  const dataUrl = useMemo(
    () => (svgData ? svgHtmlToDataUrl(svgData, { saved }) : null),
    [svgData, saved]
  );

  if (dataUrl) {
    return (
      <div
        className={`flex-shrink-0 overflow-hidden flex items-center justify-center rounded-md ${
          saved
            ? 'bg-white border border-gray-200'
            : 'bg-transparent border border-transparent'
        } ${className}`}
      >
        <img
          src={dataUrl}
          alt=""
          className="w-full h-full object-contain object-center"
          draggable={false}
        />
      </div>
    );
  }

  return (
    <div
      className={`flex-shrink-0 bg-slate-100 border border-gray-200 rounded-md flex items-center justify-center ${className}`}
    >
      <Square className="w-6 h-6 text-gray-400" />
    </div>
  );
};

export default SummaryConfigThumbnail;
